export default "__VITE_ASSET__DkGStwnu__"